export function splitName(name: string) {
  const [firstName, ...rest] = name.trim().split(' ')
  // Account for possible multiple last name
  const lastName = rest.length > 1 ? rest.join(' ') : rest.pop() || 'N/A'

  return { firstName, lastName }
}
